import { Link } from 'react-router'

import { URL_MAIN_PAGE } from '@shared/contants'
import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

import LogoIcon from '/img/tobyl/logo-horizontal-navy.png'


interface LogoProps {
  className?: string;
}

export default function Logo (props: LogoProps) {
  const { className } = props

  return (
    <Link className={cn(styles.root, className)} to={URL_MAIN_PAGE}>
      <img src={LogoIcon} alt="Тобыл - құрылыс маркеті" loading="lazy" fetchPriority="low" />
    </Link>
  )
}
